import styled from 'styled-components';

export const Conteiner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;

  width: 100%;
  height: 100%;
  padding: 20px;

  background-color: rgba(0, 0, 0, 0.4);

  z-index: 5;
  overflow: auto;
`;

export const Conteudo = styled.div`
  max-width: 80%;
  max-height: 80%;
  margin: auto;
  padding: 20px;

  background-color: white;
  border-radius: 15px;

  overflow-y: auto;
  z-index: 1;
`;

export const Cabecalho = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
`;

export const Divisor = styled.hr`
  width: 95%;
  margin: 10px 0;

  border: none;
  border-top: solid 1px ${(props) => props.theme.BACKGROUND};
`;

export const ContainerAcoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
`;
